module.exports = " <div class=userPanel _v-5714e4f3=\"\"> <img :src=avatar alt=\"\" _v-5714e4f3=\"\"> <div _v-5714e4f3=\"\"> <slot name=one _v-5714e4f3=\"\"></slot> <slot name=two _v-5714e4f3=\"\"></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5714e4f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vUserPanel.vue
 ** module id = 91
 ** module chunks = 2
 **/